export enum ReactionEmojisEnum {
    Like = "👍",
    Heart = "❤️",
    Laugh = "😀",
    Surprised = "😮"
}
